import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f6b1254"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-1 gap-3"
}
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_6 = { class: "SLAFilters__inputs" }
const _hoisted_7 = { class: "SLAFilters__actions" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "SLAFilters",
    onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"]))
  }, [
    (_ctx.isFtl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_the_select, {
            "can-deselect": "",
            value: _ctx.state.cityFromId,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.cityFromId) = $event)),
            placeholder: "Откуда",
            loading: _ctx.data_state.from_cities.is_loading,
            options: _ctx.data_state.from_cities.list,
            failed: _ctx.data_state.from_cities.is_failed,
            "error-text": "При получении списка городов произошла ошибка",
            "search-by": "name",
            label: "name",
            "infinite-scroll": "",
            onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadFromCities(_ctx.data_state.from_cities.pagination.current_page))),
            onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreFromCities(_ctx.data_state.from_cities.pagination.current_page + 1))),
            onSearch: _ctx.searchFromCity,
            onOptionBySearch: _ctx.unshiftFindedFromCity
          }, null, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.transit_cities, (city, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `transit-city-${i}`,
              class: "grid grid-cols-1 gap-3"
            }, [
              _createElementVNode("div", _hoisted_2, "Транзит №" + _toDisplayString(i + 1), 1),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_the_select, {
                  "can-deselect": "",
                  class: "w-full",
                  value: _ctx.state.transit_cities[i],
                  "onUpdate:value": ($event: any) => ((_ctx.state.transit_cities[i]) = $event),
                  placeholder: "Выберите из списка",
                  loading: _ctx.data_state.transit_cities.is_loading,
                  disabled: _ctx.data_state.transit_cities.is_loading,
                  failed: _ctx.data_state.transit_cities.is_failed,
                  options: _ctx.data_state.transit_cities.list,
                  "error-text": "При получении списка городов произошла ошибка",
                  onRefresh: _ctx.loadTransitCities
                }, null, 8, ["value", "onUpdate:value", "loading", "disabled", "failed", "options", "onRefresh"]),
                _createVNode(_component_the_button, {
                  class: "red text small",
                  onClick: ($event: any) => (_ctx.deleteTransitCity(i))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128)),
          _createVNode(_component_the_button, {
            class: "primary text small",
            onClick: _ctx.addTransitCity
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" Добавить город транзит ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_the_select, {
            "can-deselect": "",
            value: _ctx.state.cityToId,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.cityToId) = $event)),
            placeholder: "Куда",
            loading: _ctx.data_state.where_cities.is_loading,
            options: _ctx.data_state.where_cities.list,
            failed: _ctx.data_state.where_cities.is_failed,
            "error-text": "При получении списка городов произошла ошибка",
            "search-by": "name",
            label: "name",
            "infinite-scroll": "",
            onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadWhereCities(_ctx.data_state.where_cities.pagination.current_page))),
            onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreWhereCities(_ctx.data_state.where_cities.pagination.current_page + 1))),
            onSearch: _ctx.searchWhereCity,
            onOptionBySearch: _ctx.unshiftFindedWhereCity
          }, null, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (!_ctx.isFtl)
        ? (_openBlock(), _createBlock(_component_the_select, {
            key: 0,
            "can-deselect": "",
            value: _ctx.state.cityFromId,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.cityFromId) = $event)),
            placeholder: "Откуда",
            loading: _ctx.data_state.from_cities.is_loading,
            options: _ctx.data_state.from_cities.list,
            failed: _ctx.data_state.from_cities.is_failed,
            "error-text": "При получении списка городов произошла ошибка",
            "search-by": "name",
            label: "name",
            "infinite-scroll": "",
            onRefresh: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadFromCities(_ctx.data_state.from_cities.pagination.current_page))),
            onLoadmore: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadMoreFromCities(_ctx.data_state.from_cities.pagination.current_page + 1))),
            onSearch: _ctx.searchFromCity,
            onOptionBySearch: _ctx.unshiftFindedFromCity
          }, null, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch"]))
        : _createCommentVNode("", true),
      (!_ctx.isFtl)
        ? (_openBlock(), _createBlock(_component_the_select, {
            key: 1,
            "can-deselect": "",
            value: _ctx.state.cityToId,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.cityToId) = $event)),
            placeholder: "Куда",
            loading: _ctx.data_state.where_cities.is_loading,
            options: _ctx.data_state.where_cities.list,
            failed: _ctx.data_state.where_cities.is_failed,
            "error-text": "При получении списка городов произошла ошибка",
            "search-by": "name",
            label: "name",
            "infinite-scroll": "",
            onRefresh: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadWhereCities(_ctx.data_state.where_cities.pagination.current_page))),
            onLoadmore: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadMoreWhereCities(_ctx.data_state.where_cities.pagination.current_page + 1))),
            onSearch: _ctx.searchWhereCity,
            onOptionBySearch: _ctx.unshiftFindedWhereCity
          }, null, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch"]))
        : _createCommentVNode("", true),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        value: _ctx.state.shipmentTypeId,
        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.shipmentTypeId) = $event)),
        placeholder: "Тип доставки",
        "select-by": "id",
        options: _ctx.SHIPMENT_TYPES
      }, null, 8, ["value", "options"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        value: _ctx.state.periodId,
        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.periodId) = $event)),
        placeholder: "Период",
        options: _ctx.PERIOD_OPTIONS
      }, null, 8, ["value", "options"]),
      _createVNode(_component_the_select, {
        placeholder: "Компания",
        loading: _ctx.data_state.companies.is_loading,
        failed: _ctx.data_state.companies.is_failed,
        "error-text": "При получении списка компаний произошла ошибка",
        options: _ctx.data_state.companies.list,
        value: _ctx.state.companyId,
        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.companyId) = $event)),
        "infinite-scroll": "",
        "search-without-refresh": "",
        onRefresh: _cache[15] || (_cache[15] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
        onLoadmore: _cache[16] || (_cache[16] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1)))
      }, null, 8, ["loading", "failed", "options", "value"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_the_button, {
        class: "second text small mt-2",
        disabled: _ctx.loading,
        onClick: _ctx.reset
      }, {
        default: _withCtx(() => [
          _hoisted_8,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_the_button, {
        class: "primary text small mt-2",
        loading: _ctx.loading,
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_9,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}